import React from 'react'
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";
import Newwork from './Newwork';

import Header from "../inc/Header";

function NewwPage() {
  return (
    <div>
        <Header />
                    <br />
                    <br />
                    <br />
                    <br />
                    <ScrollToTop smooth top="100" color="maroon" />
                    <div className='colorbacklockt'>
                        <div className="album py-1">
                            <div className="container mt-3">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">Mantasa</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                    <Newwork/>
    </div>
  )
}

export default NewwPage